// extracted by mini-css-extract-plugin
export default {"buttonContainer":"o6QGzKjYWFZbnyoRkjzg","saveContainer":"fkPmPhvgl2h26LvBr2fl"};